module.exports = __webpack_public_path__ + "static/media/contact-support.ef4eb342.svg";